import SmoothScroll from "@/components/SmoothScroll";
import { BrochureGateProvider } from "@/components/BrochureGate";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import FloatingWidgets from "@/components/FloatingWidgets";

// Shared shell for landing & blog pages: providers + navbar + footer + widgets.
export default function SiteShell({ children }) {
  return (
    <SmoothScroll>
      <BrochureGateProvider>
        <div className="min-h-screen bg-[#f9f8f5] text-[#202124]">
          <Navbar />
          <main>{children}</main>
          <Footer />
          <FloatingWidgets />
        </div>
      </BrochureGateProvider>
    </SmoothScroll>
  );
}
